import Dashboard from 'src/wrapper/dashboard/censor';
import Account from 'src/wrapper/account';
import FuelList from 'src/wrapper/censors/fuel-list';
import FuelDetail from 'src/wrapper/censors/fuel-detail';
import TmsList from 'src/wrapper/censors/tms-list';
import TmsDetail from 'src/wrapper/censors/tms-detail';
import RepairList from 'src/wrapper/censors/repair-list';
import RepairDetail from 'src/wrapper/censors/repair-detail';
import TicketList from 'src/wrapper/tickets/list';
import TicketDetail from 'src/wrapper/tickets/detail';

export const censorRoutes = (paths) => {
  return [
    { path: paths.dashboard.index, component: Dashboard },
    { path: paths.dashboard.account, component: Account },
    { path: paths.fuels.index, component: FuelList },
    { path: paths.fuels.details, component: FuelDetail },
    { path: paths.tms.index, component: TmsList },
    { path: paths.tms.details, component: TmsDetail },
    { path: paths.repairs.index, component: RepairList },
    { path: paths.repairs.details, component: RepairDetail },
    { path: paths.tickets.index, component: TicketList },
    { path: paths.tickets.details, component: TicketDetail },
  ];
};
